import { render, staticRenderFns } from "./AiSearch.vue?vue&type=template&id=05587cb2&scoped=true&"
import script from "./AiSearch.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiSearch.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05587cb2",
  null
  
)

export default component.exports